import * as React from 'react';

import styled from '@emotion/styled';
import { Box, Flex } from '@lightspeed/flame/Core';
import { IconAdd } from '@lightspeed/flame/Icon/Add';
import { Text, TextLink } from '@lightspeed/flame/Text';

const StyledFlex = styled(Flex)`
  cursor: pointer;
`;

interface Props {
  'data-test'?: string;
  id?: string;
  onClick?: () => void;
  text: string;
  title: string;
}

export const RuleOption: React.FC<Props> = ({ text, title, ...rest }) => {
  return (
    <StyledFlex alignItems="center" justifyContent="space-between" p={4} {...rest}>
      <Box alignItems="left" width="70%">
        <Text fontSize="small" fontWeight="bold" px="1" py="0">
          {title}
        </Text>
        <Text fontSize="small" p="1" color="gray-400">
          {text}
        </Text>
      </Box>
      <Box>
        <IconAdd baseColor="blue-500" />
        <TextLink fontSize="small" p="1">
          Create
        </TextLink>
      </Box>
    </StyledFlex>
  );
};
